import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import { Colors, Fonts } from '../../styles/Variables';

export const ContainerMessage = styled('div')<{ showAlert: boolean }>`
    background: ${Colors.mauve};
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    left: 0;
    top: 0;
    width: 100%;
    text-align: center;
    padding: 10px 0;
    box-sizing: border-box;
    transition: all 0.25s ease;
    height: ${(props) => (props.showAlert ? 'auto' : '0px')};
    min-height: ${(props) => (props.showAlert ? '65px' : '0px')};
    opacity: ${(props) => (props.showAlert ? '100%' : '0')};
    overflow: hidden;

    span > svg {
        color: ${Colors.eletricViolet};
    }

    .hide {
        opacity: 0;
        height: 0px;
    }
`;

export const TextContainer = styled('div')`
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
    color: ${Colors.label};
    font-family: ${Fonts.fontDefault};

    a {
        color: ${Colors.eletricViolet};
    }
`;

export const CloseButton = styled(IconButton)`
    color: ${Colors.white};
    position: absolute;
    right: 25px;
`;
